import React from "react";
import { useMediaQuery } from "react-responsive";

function ExtraTeam() {
  const isMobile = useMediaQuery({ query: "(max-width: 30em)" });

  return (
    <section id="extra">
      <div className="padding-block-700 padding-inline">
        <div className="extra-header">Zusätzliches ärztliches Angebot</div>
        <div className="extra-item">
          <p className="extra-item-header">Dr. med. Holger Heidenreich</p>
          <p className="extra-item-sub-header">
            Facharzt für Urologie und Andrologie (nur Privatpatienten)
          </p>
        </div>
      </div>
    </section>
  );
}

export default ExtraTeam;
